interface CacheEntry<T> {
  data: T;
  timestamp: number;
}

class DataCache {
  private readonly TTL = 10 * 60 * 1000; // 10 minutes

  set<T>(key: string, data: T, region: string = 'global'): void {
    const entry: CacheEntry<T> = { data, timestamp: Date.now() };
    sessionStorage.setItem(`cache_${region}_${key}`, JSON.stringify(entry));
  }

  get<T>(key: string, region: string = 'global'): T | null {
    try {
      const stored = sessionStorage.getItem(`cache_${region}_${key}`);
      if (!stored) return null;

      const entry: CacheEntry<T> = JSON.parse(stored);
      if (Date.now() - entry.timestamp > this.TTL) {
        sessionStorage.removeItem(`cache_${region}_${key}`);
        return null;
      }
      return entry.data;
    } catch {
      return null;
    }
  }

  clearRegion(region: string): void {
    Object.keys(sessionStorage)
      .filter((key) => key.startsWith(`cache_${region}_`))
      .forEach((key) => sessionStorage.removeItem(key));
  }

  clear(): void {
    const keys = Object.keys(sessionStorage);
    keys.forEach((key) => {
      if (key.startsWith('cache_')) {
        sessionStorage.removeItem(key);
      }
    });
  }
}

export const dataCache = new DataCache();
